/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const EVENT_ENTRY_INVENTORY = 'entry_inventory'
export const EVENT_EXIT_INVENTORY = 'exit_inventory'
export const EVENT_INTERVENTION = 'intervention'
export const EVENT_LEASE_END = 'lease_end'
export const EVENT_LEASE_START = 'lease_start'
